import Edit from '../../../assets/edit1.svg';
import { useConfiguraionContext } from '../../../context/ProviderPage/Configuration';
import { ListConfiguration } from '../../../types/Configuration';
import { formatDate } from '../../../utils/date/formatDate';
import { returnCheckType } from '../../../utils/returnCheckType';
import { ListButton } from '../../Buttons/ListButton';
import { AnimateTr, ContainerListPage } from '../styles';

export const ListConfigurations = ({ data }: ListConfiguration) => {
  const { setEditOneConfiguration, setSelectedConfiguration } =
    useConfiguraionContext();

  return (
    <ContainerListPage>
      <table>
        <thead>
          <tr>
            <th className="first-table-th">Opções</th>
            <th className="list-th">Carreteiro</th>
            <th className="list-th">Imei</th>
            <th className="list-th">Data Sincronização</th>
            <th className="list-th">Régua frontal</th>
            <th className="list-th">Régua trazeira</th>
            {/* <th className="lits-th">Qualidade</th> */}
            <th className="lits-th">Distribuição</th>
            <th className="lits-th">Termômetro</th>
            <th className="list-th">Liberar</th>
            <th className="list-th">Exame Sensorial</th>
            <th className="list-th">Exame de Alizarol</th>
            <th className="list-th">Passou no Alizarol</th>
            <th className="list-th">Amostra de Qualidade</th>
            <th className="list-th">Fotos da Amostra</th>
            <th className="list-th">Fotos da Temeperatura</th>
            <th className="list-th">Amostra</th>
            <th className="list-th">Lacre</th>
            <th className="list-th">Percentual de Litragem</th>
            <th className="list-th">Percentual de tolerância</th>
            <th className="last-table-th">Dias de Validação</th>
            {/* <th className="last-table-th">Opções</th> */}
          </tr>
        </thead>
        <tbody>
          {data.map((configuration, index) => {
            const {
              // DFIDCARRETEIRO,
              // DFHORASINCRONIZACAO,
              DFDATASINCRONIZACAO,
              DFIMEI,
              DFDISTRIBUIR,
              // DFQUALIDADE,
              DFREGUAFRENTE,
              DFREGUAATRAS,
              DFNOMECARRETEIRO,
              DFLIBERARCOLETA,
              DFTERMOMENTRO,

              DFEXAMESENSORIAL,
              DFEXAMEALIZAROL,
              DFPASSOUNOALIZAROL,
              DFAMOSTRADEQUALIDE,
              DFFOTOSDEAMOSTRA,
              DFFOTOSDATEMPERATURA,
              DFAMOSTRA,
              DFLACRE,
              DFDIASDEVALIDACAO,
              DFPORCENTAGEMDETOLERANCIA,
              DFATIVARPERCENTUALDELITRAGEM,
            } = configuration;

            return (
              <AnimateTr key={index} index={index}>
                <td className="list-td-small">
                  <div>
                    <ListButton
                      {...{
                        action: () => {
                          setEditOneConfiguration(true);
                          setSelectedConfiguration(configuration);
                        },
                        icon: 'edit-secondary',
                      }}
                    />
                  </div>
                </td>
                <td className="list-td-large">
                  {DFNOMECARRETEIRO || 'Não informado'}
                </td>
                <td className="list-td-large">{DFIMEI || 'Não informado'}</td>
                <td className="list-td-medium">
                  {formatDate(DFDATASINCRONIZACAO)}
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFREGUAFRENTE)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFREGUAATRAS)}
                  />
                </td>
                {/* <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFQUALIDADE)}
                  />
                </td> */}
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFDISTRIBUIR)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFTERMOMENTRO)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFLIBERARCOLETA)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFEXAMESENSORIAL)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFEXAMEALIZAROL)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFPASSOUNOALIZAROL)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFAMOSTRADEQUALIDE)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFFOTOSDEAMOSTRA)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFFOTOSDATEMPERATURA)}
                  />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFAMOSTRA)}
                  />
                </td>
                <td className="list-td-small">
                  <img className="icon-check" src={returnCheckType(DFLACRE)} />
                </td>
                <td className="list-td-small">
                  <img
                    className="icon-check"
                    src={returnCheckType(DFATIVARPERCENTUALDELITRAGEM)}
                  />
                </td>
                <td className="list-td-small">
                  {DFPORCENTAGEMDETOLERANCIA
                    ? `${DFPORCENTAGEMDETOLERANCIA}%`
                    : 'Não informado'}
                </td>
                <td className="list-td-small">
                  {DFDIASDEVALIDACAO || 'Não informado'}
                </td>
                {/* <td className="list-td-small">
                  <div>
                    <ListButton
                      {...{
                        action: () => {
                          setSelectedConfiguration({
                            isOpen: true,
                            configuration,
                          });
                        },
                        icon: 'edit',
                      }}
                    />
                  </div>
                </td> */}
              </AnimateTr>
            );
          })}
        </tbody>
      </table>
    </ContainerListPage>
  );
};
